import {InitQualitiesAction, QualityAction, QualityType} from "../state/qualities";
import {fork, put, select, takeEvery} from "redux-saga/effects";
import {Storage, ToStorage,} from "./storage";
import {AppState} from "../state";

export function* qualities() {

    yield takeEvery<QualityAction>("QualityAction",  function * (action) {
        const qualities:QualityType = yield select((app:AppState) => app.qualities);
        ToStorage("rczqual", qualities);
    });

    yield fork(Storage, "rczqual", function * (value: any) {
        if (value) {
            const v = value;
            if (Array.isArray(v)) {
                const data = v.map(x => {
                    const url = x.url;
                    const slug = x.slug;
                    if (slug && slug)
                        return {
                            slug,
                            url
                        }
                    return null;
                }).filter(x => !!x);
                yield put<InitQualitiesAction>({
                    type: "InitQualities",
                    payload: data as any
                });
            }
        }
    });
}